import React from "react";
import Levelskill from "./levelskill";
import Skillpannel from "./skillpanel";
// import Profile from "./../../assets/profile.png";


// import ntvideo from "./nat.webm"; 

import { TypeAnimation } from 'react-type-animation';

import "./about.css"; // Your CSS file

const Profile="https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744653002/profile_jflf7p.png";
const ntvideo= "https://res.cloudinary.com/dmnpdzcvd/video/upload/v1744653617/nat_tgkskm.webm";

const About = () => {
  return (
    <section id="about">
     {/* Video background */}
     <div className="video-background">
        <video autoPlay muted loop className="background-video">
          <source src={ntvideo} type="video/webm" />
        </video>
      </div>
      
      <div className="row">
        <h2 className="sub-title">About Me</h2>

        {/* Profile section */}
        <div className="profile" data-aos="zoom-in-up" data-aos-duration="1200">
          <img src={Profile} alt="profile" className="profile-img" />
        </div>

        {/* Animated text */}
        <TypeAnimation
          sequence={[
            // Same substring at the start will only be typed out once, initially
            ' My name is ABID Hasan. I am from Barishal and Hometown Bakai ,Gournodi where I was Born. I have complete my SSC in Bakai Niranjan High School and HSC in Shahid Smriti College. Now, I am study in computer subjects of IUBAT University.',
            1800
          ]}
          className="ab"
          wrapper="p"
          speed={40}
          style={{ display: 'inline-block' }}
          repeat={Infinity}
        />

        {/* Level Skills Component */}
        <Levelskill />
      </div>

      {/* Skill Panel */}
      <Skillpannel />
    </section>
  );
};

export default About;
